import React from "react";
import { Link } from "react-router-dom";
import ChevronRightIcon from "../OpticksIcons/ChevronRightIcon";
import "./OpticksBreadcrumbs.css";

interface Breadcrumb {
  name: string;
  path: string;
}

const OpticksBreadcrumbs = ({ config }: { config: Breadcrumb[] }) => {
  return (
    <div className="opticks-breadcrumbs">
      {config.map((el, i) => {
        if (i < config.length - 1) {
          return (
            <React.Fragment key={i}>
              <Link to={el.path}>
                <span>{el.name}</span>
              </Link>
              <ChevronRightIcon />
            </React.Fragment>
          );
        }
        return <b key={i}>{el.name}</b>;
      })}
    </div>
  );
};

export default OpticksBreadcrumbs;
